import "./new.scss";
import Sidebar from "../components/sidebar/Sidebar";
import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  addDoc,
  collection,
  serverTimestamp,
} from "firebase/firestore";
import { db, storage } from "../../../firebase";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { useNavigate } from "react-router-dom";
import Navbar1 from "../../main/Navbar1";
import Spinner from "../../Spinner";

let id = '';
const NewPost = () => {
  const { t } = useTranslation();
  const [file, setFile] = useState("");
  const [data, setData] = useState({});
  const [per, setPerc] = useState(null);
  const navigate = useNavigate();

  if(localStorage.getItem('id') != null){
    id = localStorage.getItem('id');
  }
  const [post, setPost] = useState({
    img : '',
    title: '',
    content: '',
    author: '',
    createdAt: null
  });

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    
  }, []);

  const uploadFile = async () => {
    const name = new Date().getTime() + file.name;

    console.log(name);
    if(!file){
        setIsLoading(false);
        window.alert('Veuillez choisir le fichier à enregistrer');
    }
    else{
        const storageRef = ref(storage, `/files/${file.name}`);
        const uploadTask = uploadBytesResumable(storageRef, file);

        uploadTask.on(
        "state_changed",
        (snapshot) => {
            const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            console.log("Upload is " + progress + "% done");
            setPerc(progress);
            switch (snapshot.state) {
            case "paused":
                console.log("Upload is paused");
                break;
            case "running":
                console.log("Upload is running");
                break;
            default:
                break;
            }
        },
        (error) => {
            setIsLoading(false);
            console.log(error);
        },
        () => {
            getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) =>{
              setData((prev) => ({ ...prev, img: downloadURL }));
            });
        }
        );
    }
  };

  const handleInput = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setPost({ ...post, [name]: value });
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await uploadFile().then( async()=>{
        let {img, title, content, author} = post;
        img = data.img;
        author = id;
        const postData = {
            img,
            title,
            content,
            author
        }
        try {
            await addDoc(collection(db, "posts"), {
            ...postData,
            createdAt: serverTimestamp(),
            });
            window.alert("Enregistré");
            navigate(-1);
        } catch (error) {
            setIsLoading(false);
            if(error.toString().includes("offline")){
                window.alert('Pas de connexion internet')
            }
            else{
                window.alert(error)
            }
          }
      });
    } catch (err) {
      setIsLoading(false);
      console.log(err);
    }
    
  };

  const handleReturn = async () => {
    navigate(-1);
  }

  if (isLoading) {
    return <Spinner />
  }

  return (
    <div className="new">
      <Sidebar />
      <div className="newContainer">
        <Navbar1 />
        <input type="button" className="btn btn-primary m-3" value={t('return')} onClick={handleReturn}/>
        <div className="top">
          <h1>{t('new_post')}</h1>
        </div>
        <div className="bottom">
          <div className="left">
            <img
              src={
                file
                  ? URL.createObjectURL(file)
                  : "https://icon-library.com/images/no-image-icon/no-image-icon-0.jpg"
              }
              alt={file.path}
            />
          </div>
          <div className="right">
            <form onSubmit={handleAdd}>
              <div className="formInput">
                <label htmlFor="file">
                  Image: <DriveFolderUploadOutlinedIcon className="icon" />
                </label>
                <input
                  type="file"
                  id="file"
                  accept='.png, .jpg'
                  style={{ display: "none" }}
                  onChange={(e) => setFile(e.target.files[0])}
                />
              </div>
              <div className="formInput">
                  <label>{t('title')}</label>
                  <input
                    type="text"
                    name={t('title')}
                    placeholder={t('post_title')}
                    value={post.title}
                    onChange={handleInput}
                  />
              </div>
              {/**
               * value ={step.patentNumber} onChange={handleInput}
               * 
               */}
              <div className="mb-3">
                  <label htmlFor="exampleInputEmail1" class="form-label">{t('post_content')}</label>
                  <textarea name="content" required value={post.content} id="exampleInputEmail1" onChange={handleInput} cols="100" rows="10"></textarea>
                                </div>
              <button disabled={per !== null && per < 100} type="submit">
                {t('save')}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewPost;
